import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import bdService from "../../../services/bodega.service";
import bdMaestro from "../../../services/maestros.service";

// Grilla agGrid
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import { useSelector } from "react-redux";

import { useSnackbar } from "notistack"; //Para alertas notificaciones
import { pink } from "@mui/material/colors";

//* Helper de confirmacion dialog
import ConfirmationDialog from "../../../helpers/ConfirmationDialog";
import { DatePicker } from "@mui/x-date-pickers";
//* Fecha formato
import { format } from "date-fns";
import CrearPdf from "../../../components/impresiones/infview";
// import { Viewer, Worker } from "@react-pdf-viewer/core";
// import ImpPDf from "../../components/Pdf";
const Inventario = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [sucursales, setSucursales] = useState([]);
  const [dataGridData, setDataGridData] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState(null);
  const [selectedBodega, setBodega] = useState([]);
  const [isBloqueo, setIsBloqueo] = useState(false);
  const [isModificar, setModificar] = useState(false);
  const [executeSearch, setExecuteSearch] = useState(false);
  //**************************************** */
  // Dialogos
  //**************************************** */
  const [mostrarVentanaEscaneo, setMostrarVentanaEscaneo] = useState(false);
  const [mostrarVentanaImpresion, setMostrarVentanaImpresion] = useState(false);
  const [openDialogConfirmacion, setOpenDialogConfirmacion] = useState(false);
  const [valueRadio, setValueRadio] = React.useState("T");
  //******************* Fecha ************** */
  const [selectedDate, setSelectedDate] = useState(null);
  //**************************************** */
  // Busqueda en la grilla
  //**************************************** */
  const [sCodigo, setsCodigo] = useState("");
  const [sCodBarra, setsCodBarra] = useState("");
  const [sNombre, setsNombre] = useState("");
  //**************************************** */
  const gridRef = useRef(null);
  //**************************************** */
  // REDUX Para extraer los datos de usuario */
  //**************************************** */
  const { usuario } = useSelector((state) => state.user);
  //**************************************** */
  // const [sPDF, setPDF] = useState(null);
  // const [mostrarPDF, setmostrarPDF] = useState(false);
  const FiltradoGrilla = () => {
    if (gridRef.current && gridRef.current.api) {
      const gridApi = gridRef.current.api;
      const filterModel = {};

      if (sNombre) {
        filterModel["Nombre"] = {
          type: "contains",
          filter: sNombre,
        };
      }

      if (EstadoGrilla === "A") {
        filterModel["Estado"] = {
          type: "notEqual",
          filter: "I",
        };
      } else if (EstadoGrilla === "I") {
        filterModel["Estado"] = {
          type: "equals",
          filter: "I",
        };
      }

      setTimeout(() => {
        gridApi.setFilterModel(filterModel);
        gridApi.onFilterChanged();
      }, 0);
    }
  };

  const FiltradoGrillaEstado = (filtroEstado) => {
    if (gridRef.current && gridRef.current.api) {
      const gridApi = gridRef.current.api;
      const filterModel = {};

      if (filtroEstado === "A") {
        filterModel["Estado"] = {
          type: "notEqual",
          filter: "I",
        };
      } else if (filtroEstado === "I") {
        filterModel["Estado"] = {
          type: "equals",
          filter: "I",
        };
      }

      setTimeout(() => {
        gridApi.setFilterModel(filterModel);
        gridApi.onFilterChanged();
      }, 0);
    }
  };

  const AnularFiltro = () => {
    if (gridRef.current && gridRef.current.api) {
      const gridApi = gridRef.current.api;
      setTimeout(() => {
        gridApi.setFilterModel(null);
        gridApi.onFilterChanged();
      }, 0);
    }
  };

  const handleSearchNombre = (event) => {
    setsNombre(event.target.value);
    FiltradoGrilla();
  };

  const handleSearch = useCallback(() => {
    setsNombre("");
    setMostrarVentanaEscaneo(false);

    var filteredData = [];
    if (sNombre.length > 0) {
      filteredData = dataGridData.filter((item) => {
        return item.Nombre?.toLowerCase().includes(sNombre.toLowerCase());
      });
    } else if (sCodBarra.length > 0) {
      filteredData = dataGridData.filter((item) => {
        return item.CodigoBarra.toLowerCase().includes(sCodBarra.toLowerCase());
      });
    } else if (sCodigo.length > 0) {
      const formattedCodigo = sCodigo.replace(/-/g, ""); // Eliminar el carácter "-" de sCodigo
      filteredData = dataGridData.filter((item) => {
        const formattedCodigoFormato = item.CodigoFormato.replace(/-/g, ""); // Eliminar el carácter "-" de CodigoFormato
        return formattedCodigoFormato
          .toLowerCase()
          .includes(formattedCodigo.toLowerCase());
      });
    }
    let firstMatchingRowIndex;
    if (filteredData.length > 0) {
      if (sNombre.length > 0) {
        alert("nombre");
        firstMatchingRowIndex = dataGridData.findIndex(
          (item) =>
            item.Nombre.toLowerCase() === filteredData[0].Nombre.toLowerCase()
        );
      } else if (sCodBarra.length > 0) {
        firstMatchingRowIndex = dataGridData.findIndex(
          (item) =>
            item.CodigoBarra.toLowerCase() ===
            filteredData[0].CodigoBarra.toLowerCase()
        );
      } else if (sCodigo.length > 0) {
        firstMatchingRowIndex = dataGridData.findIndex(
          (item) =>
            item.CodigoFormato.toLowerCase() ===
            filteredData[0].CodigoFormato.toLowerCase()
        );
      }
    }
    const goToRow = (rowIndex) => {
      if (gridRef.current.api) {
        const rowNode = gridRef.current.api.getRowNode(`${rowIndex}`);
        if (rowNode) {
          rowNode.setSelected(true);
          gridRef.current.api.ensureNodeVisible(rowNode, "top");
        }
      }
    };
    goToRow(firstMatchingRowIndex);
    setExecuteSearch(false);
  }, [sNombre, sCodBarra, sCodigo, dataGridData, gridRef]);

  useEffect(() => {
    if (executeSearch) {
      handleSearch();
    }
  }, [executeSearch, handleSearch]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setExecuteSearch(true);
    }
  };

  const handleCodigoChange = (event) => {
    setsCodigo(event.target.value);
    setsCodBarra("");
    setsNombre("");
  };
  const handleCodBarraChange = (event) => {
    setsCodigo("");
    setsCodBarra(event.target.value);
    setsNombre("");
  };

  // ********************************************************** */
  // ****************** Llenado Sucursal ********************** */
  // ********************************************************** */
  const CargarBodegas = async () => {
    try {
      const datos = await bdMaestro.Bodegas(-1, "T");
      if (datos.status === 200) {
        // Llenado
        setSucursales(datos.data.Sucursales);
      } else if (datos.status === 400) {
        // Esta mal
        //console.log(datos);
      }
    } catch (error) {
      // Manejo del error si ocurre
      console.log(error);
    }
  };
  // ********************************************************** */

  useEffect(() => {
    CargarBodegas();
  }, []);

  // ********************************************************** */
  const handleCellValueChanged = async (params) => {
    const { data, column, value } = params;

    try {
      if (column.colId === "CodigoBarra") {
        let bSalir = false;
        let StrError;
        if (value === null) {
          StrError =
            "¡¡El valor no puede estar vacio o en blanco no se grabara datos!!";
          bSalir = true;
        } else if (value.length > 15) {
          StrError = "El valor no puede superar los 15 caracteres";
          bSalir = true;
        } else {
          bSalir = false;
        }
        if (bSalir) {
          // ********************************************************** */
          //Error para que aparezca
          // ********************************************************** */
          enqueueSnackbar(StrError, {
            variant: "info",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          // ********************************************************** */
          //*** Devuelvo el valor al anterior
          // ********************************************************** */
          params.data.CodigoBarra = params.oldValue;
          params.api.redrawRows({ rowNodes: [params.node] });
          // ********************************************************** */
          return false;
        } else {
          // 'Revisar si existe el codigo utilizado existe en la bd'
          const gridApi = gridRef.current.api;
          const rowId = params.node.id; // Obtener el rowId de la fila actual
          const rowNode = gridApi.getRowNode(rowId); // Obtén el nodo de la fila actual
          let existeCodigoBarra = false;

          gridApi.forEachNodeAfterFilter((node) => {
            // Verifica si el nodo no es la fila actual y coincide con el valor especificado
            if (node !== rowNode && node.data.CodigoBarra === value) {
              existeCodigoBarra = true;
              return;
            }
          });

          if (existeCodigoBarra) {
            enqueueSnackbar(
              "Código de barra ya existe en la grilla no se puede grabar",
              {
                variant: "warning",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
              }
            );
            // ********************************************************** */
            // *** Devuelvo el valor al anterior
            // ********************************************************** */
            params.data.CodigoBarra = params.oldValue;
            params.api.redrawRows({ rowNodes: [params.node] });
            // ********************************************************** */
            return false;
            // Puedes realizar la acción que desees, como limpiar el valor o mostrar un mensaje de error.
          }
        }
      }
      // ********************************************************** */
      // Grabando datos a la base de dato
      // ********************************************************** */
      const response = await bdService.Put_Inventario(
        selectedSucursal,
        selectedBodega,
        data.Codigo,
        data.CodigoBarra,
        data.Cantidad
      );
      // ********************************************************** */
      if (response.status === 200) {
        enqueueSnackbar(`¡¡¡Registro actualizado!!!`, {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      } else {
        // ********************************************************** */
        // Restaurar el valor original
        // ********************************************************** */
        //Error para que aparezca
        // ********************************************************** */
        enqueueSnackbar(`Error en grabación ${response.data.msg}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        // ********************************************************** */
        if (column.colId === "CodigoBarra") {
          params.data.CodigoBarra = params.oldValue;
        } else {
          params.data.Cantidad = params.oldValue;
        }
        // Actualizar la fila en la grilla
        params.api.redrawRows({ rowNodes: [params.node] });
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      console.error(error);
      console.log("Error ", error);
    }
  };

  // ********************************************************** */
  // ***      Llamada cuando selecciono en el combobox     **** */
  // ********************************************************** */
  // Cargando grilla
  // ********************************************************** */

  const CargarGrilla = async (Sucursal, Bodega) => {
    try {
      const response = await bdService.Inventario(Sucursal, Bodega, "*", "*");
      if (response.status === 200) {
        // Actualizar los datos del DataGrid
        const datagrid = response.data.inventario;
        const datagridWithId = datagrid.map((row, index) => ({
          ...row,
          id: `${row.CodigoFormato}_${index}`,
        }));
        // ********************************************************** */
        // Datos de la grilla
        // ********************************************************** */
        setDataGridData(datagridWithId);
        // ********************************************************** */
        FiltradoGrillaEstado(EstadoGrilla);
        // ********************************************************** */
      } else {
        enqueueSnackbar(
          `Error en extraer datos del inventario: ${response.data.msg}`,
          {
            variant: "error",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          }
        );
      }
    } catch (error) {
      enqueueSnackbar(`Error: ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
  };
  const handleChangeComboBox = async (event, datos) => {
    if (datos) {
      try {
        setSelectedSucursal(datos.Sucursal);
        setBodega(datos.Bodega);
        setIsBloqueo(true);
        await CargarGrilla(datos.Sucursal, datos.Bodega);
      } catch (error) {
        enqueueSnackbar(`Error: ${error}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    }
  };

  const cellEditorSelector = (params) => {
    //Funciona para capturar los datos de entrada.
    // console.log("Aqui");
    // console.log(params);
    // console.log("fin");
  };
  // console.log(usuario.TipoUsuario !== "1" ? isModificar : false);
  const columns_datagid = [
    {
      field: "CodigoFormato",
      headerName: "Código",
      width: 150,
    },
    {
      field: "CodigoBarra",
      headerName: "Código de Barras",
      width: 150,
      length: 3,
      editable: usuario.TipoUsuario <= "5" ? isModificar : false,
    },
    {
      field: "Nombre",
      headerName: "Nombre",
      filter: true,
      width: 400,
    },
    {
      field: "Unidad",
      headerName: "Unidad",
      width: 150,
      // headerAlign: "center",
    },
    {
      field: "Cantidad",
      headerName: "Cantidad",
      width: 100,
      editable: isModificar,
      cellStyle: { textAlign: "right" },
      cellEditorSelector: cellEditorSelector,
      type: "rightAligned",
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        // min: 1,
        // max: 100,
        precision: 2,
        textAlign: "right", // Establece el texto a la derecha durante la edición
        //useFormatterService: true,
      },
      valueFormatter: function (params) {
        if (params.value !== null && params.value !== undefined) {
          // Formatear el número con separador de miles y decimales
          const numberFormat = new Intl.NumberFormat("es-CL");
          const formattedNumber = numberFormat.format(params.value);
          return formattedNumber;
        }
        return null;
      },
    },
    {
      field: "StockActual",
      headerName: "Stk.Actual",
      width: 100,
      cellStyle: { textAlign: "right" },
      cellEditorSelector: cellEditorSelector,
      type: "rightAligned",
      cellEditor: "agNumberCellEditor",
      cellEditorParams: {
        // min: 1,
        // max: 100,
        precision: 2,
        textAlign: "right", // Establece el texto a la derecha durante la edición
        //useFormatterService: true,
      },
      valueFormatter: function (params) {
        if (params.value !== null && params.value !== undefined) {
          // Formatear el número con separador de miles y decimales
          const numberFormat = new Intl.NumberFormat("es-CL");
          const formattedNumber = numberFormat.format(params.value);
          return formattedNumber;
        }
        return null;
      },
    },
    {
      field: "Estado",
      headerName: "Estado",
      hide: true,
      filter: true,
    },
  ];

  const gridOptions = {
    pagination: false,
    paginationPageSize: 30,
  };

  const handleTerminar = () => {
    //setIsEditing(false);
    setModificar(false);
  };

  // ********************************************************** */
  const handleCancel = () => {
    setSucursales([]);
    setDataGridData([]);
    setSelectedSucursal(null);
    setBodega([]);
    setIsBloqueo(false);
    setModificar(false);
    setMostrarVentanaEscaneo(false);
    setExecuteSearch(false);
    setsCodigo("");
    setsCodBarra("");
    setsNombre("");
    CargarBodegas();
  };
  // ********************************************************** */
  // Dialogo para confirmaci+on
  // ********************************************************** */
  const handleOpenDialogConfirmacion = () => {
    setOpenDialogConfirmacion(true);
  };
  const handleCloseDialogConfirmacion = () => {
    setOpenDialogConfirmacion(false);
  };
  const handleNoConfirmacion = () => {};

  const handleSiConfirmacion = async () => {
    try {
      // ********************************************************** */
      //  Esta es la opcion para confirmar.
      // ********************************************************** */
      const response = await bdService.Put_Inventario_Inicializar(
        selectedSucursal,
        selectedBodega
      );
      if (response.status === 200) {
        // ********************************************************** */
        enqueueSnackbar(`¡¡¡Registros inicializados!!!`, {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        // ********************************************************** */
        // Recargar grilla para ver nuevos datos
        // ********************************************************** */
        await CargarGrilla(selectedSucursal, selectedBodega);
        // ********************************************************** */
      } else {
        // ********************************************************** */
        // Restaurar el valor original
        // ********************************************************** */
        //Error para que aparezca
        // ********************************************************** */
        enqueueSnackbar(`Error en grabación ${response.data.msg}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        // ********************************************************** */
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      console.error(error);
      // console.log("Error ", error);
    }
    // ******************************************************** */
  };
  // ********************************************************** */
  //                  Ventana modal busqueda                    */
  // ********************************************************** */
  const handleClickOpen = () => {
    setsNombre("");
    AnularFiltro();
    setMostrarVentanaEscaneo(true);
  };
  const handleClose = () => {
    setMostrarVentanaEscaneo(false);
  };
  // ********************************************************** */
  //                  Ventana modal Impresion                  */
  // ********************************************************** */
  const handleClickOpenImpresion = () => {
    setMostrarVentanaImpresion(true);
    // setmostrarPDF(false);
  };
  const handleCloseImpresion = () => {
    setMostrarVentanaImpresion(false);
  };

  const handleChangeRadio = (event) => {
    setValueRadio(event.target.value);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleImprimirPDF = async () => {
    /* Crear PDF*/
    if (selectedDate !== null && selectedDate !== undefined) {
      const fechaFormateada = format(new Date(selectedDate), "ddMMyyyy");
      // console.log(fechaFormateada);
      // console.log(valueRadio);
      try {
        // ********************************************************** */
        //  Extrallendo datos para exportar a pdf
        // ********************************************************** */
        const response = await bdService.Inventarioinforme(
          selectedSucursal,
          selectedBodega,
          valueRadio,
          fechaFormateada
        );
        if (response.status === 200) {
          // ********************************************************** */
          //* Generar Reporte
          // ********************************************************** */
          const registros = response.data.inventario;
          // Generar el PDF
          // setPDF(URL.createObjectURL(await CrearPdf({ Registros: registros })));
          await CrearPdf({ Registros: registros });
          // setmostrarPDF(true);
          setMostrarVentanaImpresion(false);
          // ********************************************************** */
        } else {
          // ********************************************************** */
          // Restaurar el valor original
          // ********************************************************** */
          //Error para que aparezca
          // ********************************************************** */
          enqueueSnackbar(
            `Error no se pudo obtener datos de la base de datos ${response.data.msg}`,
            {
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            }
          );
          // ********************************************************** */
        }
      } catch (error) {
        enqueueSnackbar(`Error try ${error}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        console.error(error);
        console.log("Error ", error);
      }
      // ******************************************************** */
    } else {
      // ********************************************************** */
      // Restaurar el valor original
      // ********************************************************** */
      //Error para que aparezca
      // ********************************************************** */
      enqueueSnackbar(`Digite o seleccione una fecha para poder continuar`, {
        variant: "info",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      // ********************************************************** */
    }
  };

  const handleCancelarImpresion = () => {
    setMostrarVentanaImpresion(false);
  };

  // ********************************************************** */
  // ****            Botones al modificar                  **** */
  // ********************************************************** */
  const handleEdit = () => {
    setModificar(true);
  };
  // ********************************************************** */
  //   Radio button
  // ********************************************************** */
  const [EstadoGrilla, setEstadoGrilla] = React.useState("A");

  const handleChangeEstado = (event) => {
    setEstadoGrilla(event.target.value);
    setsNombre(""); /*Limpio el buscador de nombre*/
    FiltradoGrillaEstado(event.target.value);
  };

  const controlProps = (item) => ({
    checked: EstadoGrilla === item,
    onChange: handleChangeEstado,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": item },
  });
  //*********************************************************** */
  return (
    <div>
      <Container maxWidth="lg">
        <Container maxWidth="lg" sx={{ mt: 1 }}></Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Box
              borderRadius="8px"
              sx={{ boxShadow: 1, backgroundColor: "#FFFFFF" }}
            >
              <Box sx={{ color: "text.secondary", textAlign: "center" }}>
                Inventario
              </Box>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={sucursales}
                    getOptionLabel={(option) => option.Nombre}
                    disabled={isBloqueo}
                    onChange={handleChangeComboBox}
                    sx={{ width: "100%", p: 2 }}
                    isOptionEqualToValue={(option, value) =>
                      option.Nombre === value.Nombre
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Seleccione - Sucursales" />
                    )}
                  />
                </Grid>
              </Grid>

              {isBloqueo ? (
                <Box sx={{ color: "text.secondary", p: 2 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={6} sm={3} md={3} lg={3}>
                      <Button
                        variant="outlined"
                        onClick={handleEdit}
                        disabled={isModificar}
                        sx={{ width: "100%", mr: 1 }}
                      >
                        Modificar
                      </Button>
                    </Grid>
                    <Grid item xs={6} sm={3} md={3} lg={3}>
                      <Button
                        variant="outlined"
                        onClick={handleOpenDialogConfirmacion}
                        disabled={isModificar}
                        sx={{ width: "100%", mr: 1 }}
                      >
                        Inicializar
                      </Button>
                      <ConfirmationDialog
                        open={openDialogConfirmacion}
                        onClose={handleCloseDialogConfirmacion}
                        title="¿Está seguro de inicializar el inventario?"
                        onConfirm={handleSiConfirmacion}
                        onCancel={handleNoConfirmacion}
                      />
                    </Grid>
                    <Grid item xs={6} sm={3} md={3} lg={3}>
                      <Button
                        variant="outlined"
                        onClick={handleClickOpenImpresion}
                        disabled={isModificar}
                        sx={{ width: "100%", mr: 1 }}
                      >
                        Verificar
                      </Button>
                      <Dialog
                        open={mostrarVentanaImpresion}
                        onClose={handleCloseImpresion}
                        maxWidth="xs sm md lg"
                      >
                        <DialogTitle>Inventario Verificación</DialogTitle>
                        <DialogActions>
                          <FormControl>
                            {/* <FormLabel id="demo-controlled-radio-buttons-group">
                              Inventario
                            </FormLabel> */}
                            <Box sx={{ color: "text.secondary", p: 2 }}>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <DatePicker
                                  label="Fecha"
                                  value={selectedDate}
                                  onChange={handleDateChange}
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} md={12} lg={12}>
                                <RadioGroup
                                  aria-labelledby="demo-controlled-radio-buttons-group"
                                  name="controlled-radio-buttons-group"
                                  value={valueRadio}
                                  onChange={handleChangeRadio}
                                >
                                  <FormControlLabel
                                    value="T"
                                    control={<Radio />}
                                    label="Todo"
                                  />
                                  <FormControlLabel
                                    value="S"
                                    control={<Radio />}
                                    label="Lo que Sobra"
                                  />
                                  <FormControlLabel
                                    value="F"
                                    control={<Radio />}
                                    label="Lo que Falta"
                                  />
                                </RadioGroup>
                              </Grid>
                            </Box>
                            <Grid container spacing={1}>
                              <Grid item xs={6} sm={6} md={6} lg={6}>
                                <Button
                                  variant="contained"
                                  color="success"
                                  onClick={handleImprimirPDF}
                                  sx={{ width: "100%", mr: 1 }}
                                >
                                  Imprimir
                                </Button>
                              </Grid>
                              <Grid item xs={6} sm={6} md={6} lg={6}>
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  onClick={handleCancelarImpresion}
                                  sx={{ width: "100%", mr: 1 }}
                                >
                                  Cancelar
                                </Button>
                              </Grid>
                            </Grid>
                          </FormControl>
                        </DialogActions>
                      </Dialog>
                    </Grid>
                    <Grid item xs={6} sm={3} md={3} lg={3}>
                      <Button
                        variant="outlined"
                        onClick={handleTerminar}
                        disabled={!isModificar}
                        sx={{ width: "100%", mr: 1 }}
                      >
                        Terminar
                      </Button>
                    </Grid>
                    <Grid item xs={6} sm={3} md={3} lg={3}>
                      <Button
                        variant="outlined"
                        onClick={handleCancel}
                        disabled={isModificar}
                        sx={{ width: "100%", mr: 1 }}
                      >
                        Cancelar
                      </Button>
                    </Grid>
                    <Grid item xs={6} sm={3} md={3} lg={3}>
                      <Button
                        variant="outlined"
                        onClick={handleClickOpen}
                        sx={{ width: "100%", mr: 1 }}
                        disabled={isModificar}
                      >
                        Buscar
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              ) : // </Box>
              null}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {selectedSucursal && mostrarVentanaEscaneo && (
              <Dialog
                maxWidth="xs sm md"
                open={mostrarVentanaEscaneo}
                onClose={handleClose}
              >
                <DialogTitle>Busqueda de datos</DialogTitle>
                <Box sx={{ color: "text.secondary", p: 2 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        label="Código"
                        fullWidth
                        value={sCodigo}
                        onChange={handleCodigoChange}
                        onKeyDown={handleKeyDown}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        label="Código Barra"
                        value={sCodBarra}
                        fullWidth
                        onChange={handleCodBarraChange}
                        onKeyDown={handleKeyDown}
                      />
                    </Grid>
                  </Grid>
                </Box>
                <DialogActions>
                  <Button onClick={handleSearch}>Buscar</Button>
                  <Button onClick={handleClose}>Cancelar</Button>
                </DialogActions>
              </Dialog>
            )}
            {selectedSucursal && (
              <Grid container spacing={1}>
                <Grid
                  sx={{ height: "800px", width: "100%" }}
                  className="ag-theme-alpine"
                >
                  Activo <Radio {...controlProps("A")} />
                  Inactivo
                  <Radio
                    {...controlProps("I")}
                    sx={{
                      color: pink[800],
                      "&.Mui-checked": {
                        color: pink[600],
                      },
                    }}
                  />
                  Todo
                  <Radio {...controlProps("T")} color="secondary" />
                  <TextField
                    label="Buscar por Descripción"
                    fullWidth
                    value={sNombre}
                    onChange={handleSearchNombre}
                  />
                  {/* {mostrarPDF && (
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                      <Viewer fileUrl={sPDF}></Viewer>
                    </Worker>
                  )} */}
                  <AgGridReact
                    ref={gridRef}
                    columnDefs={columns_datagid.map((column) => ({
                      ...column,
                      suppressMovable: true,
                    }))}
                    rowData={dataGridData}
                    gridOptions={gridOptions}
                    enterNavigatesVertically={true}
                    enterNavigatesVerticallyAfterEdit={true}
                    singleClickEdit={true}
                    onCellValueChanged={handleCellValueChanged}
                    // onGridReady={handleGridReady}
                  ></AgGridReact>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Inventario;
